import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 90000 });

export async function analyzeImage(payload) {
  const { data } = await http.post("/analyze-image", payload);
  return data;
}

export async function generateText(payload) {
  const { data } = await http.post("/generate-text", payload);
  return data;
}

export async function refineText(payload) {
  const { data } = await http.post("/refine-text", payload);
  return data;
}

export async function getRateLimit() {
  const { data } = await http.get("/rate-limit-status");
  return data;
}

export async function getSeoPages() {
  const { data } = await http.get("/seo-pages");
  return data.pages;
}

export async function getSeoPage(slug) {
  const { data } = await http.get(`/seo-pages/${slug}`);
  return data;
}

export function track(event, meta = {}) {
  // fire-and-forget, cookie-free analytics
  try {
    http.post("/analytics", { event, meta }).catch(() => {});
  } catch (e) {
    /* ignore */
  }
}
